import React, { useState } from "react";
import { Search } from "lucide-react";
import { Link } from "react-router-dom";
import TableComponent from "../../../shared/components/table";
import { BaliffCaseFolderColumns } from "../../../shared/components/table/columns/baliffCaseFolderColumns";
import { SortingState } from "@tanstack/react-table";
import { ARROW_LEFT } from "../../../assets";

const CaseFolders = () => {
  const [sorting, setSorting] = useState<SortingState>([]);
  const [searchTerm, setSearchTerm] = useState("");

  const data = [
    {
      sn: 1,
      date_assigned: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      suit_number: "CV/3047/2018",
      details: "View",
      assigned_bailiff: "Israel John",
      status: "Awaiting services",
      time_spent: "1hr",
    },
  ];

  const filteredData = data.filter((item) =>
    item.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="flex flex-col h-full  min-h-screen">
      <div className="bg-white px-8 py-6 border-b border-[#E9EAEB]">
        <h1 className="text-2xl font-bold text-[#1A1A1A]">
          Ready for service
        </h1>
      </div>

      <div className="px-8 py-4 flex flex-col gap-y-6">
        <div className="flex items-center border-b border-[#E9EAEB] w-full gap-x-2 text-sm text-[#464255] pb-5">
          <Link to="/baliff/overview" className="hover:text-[#00B074]">
            Home
          </Link>
          <span className="text-[#9CA3AF]">{">"}</span>
          <span className="font-medium text-[#1A1A1A]">
            Case folder history
          </span>
        </div>

        <div className="relative w-full max-w-[300px]">
          <input
            type="text"
            placeholder="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-4 pr-10 py-2.5 rounded-lg border border-[#D0D5DD] focus:outline-none focus:border-[#00B074] bg-white text-sm"
          />
          <Search className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#9A9A9A]" />
        </div>
      </div>

      <div className="flex-1 px-8 pb-10">
        <div className="bg-white rounded-2xl">
          <TableComponent
            DATA={filteredData}
            // @ts-ignore
            COLUMNS={BaliffCaseFolderColumns}
            sorting={sorting}
            setSorting={setSorting}
          />

          <div className="flex items-center justify-between px-6 py-4 border-t border-[#E4E7EC] text-sm text-[#667085]">
            <div className="flex items-center gap-2">
              <span>
                Page <span className="font-medium">1</span> of{" "}
                <span className="font-medium">10</span>
              </span>
            </div>
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <button className="px-3 py-1.5 rounded-lg border border-[#D0D5DD] bg-white hover:bg-gray-50">
                  Previous
                </button>
                <button className="px-3 py-1.5 rounded-lg border border-[#D0D5DD] bg-white hover:bg-gray-50">
                  Next
                </button>
              </div>
              <div className="flex items-center gap-2">
                <span>Entries per page:</span>
                <select className="border border-[#D0D5DD] rounded-lg px-2 py-1 bg-white focus:outline-none text-sm">
                  <option>10</option>
                  <option>20</option>
                  <option>50</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaseFolders;
